import React from 'react';
import ReactDOM from 'react-dom';
import {
    Router,
    browserHistory
} from "react-router";
import routes from "./jsx/routes";

import "./style/reset.css";
import "./style/font-awesome/css/font-awesome.min.css";
import "./style/main-style.css";
import {unregister as unregisterServiceWorker} from './registerServiceWorker';



//import './index.css';
window.myAppContainer = document.getElementById("mainContainer");
ReactDOM.render(< Router routes={routes} history={browserHistory} />, window.myAppContainer);
unregisterServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js